import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';

const TAGLINE_ARIA =
  'Know where to sit, what to order, minimum price, crowd vibe and more.';

/**
 * Stag discovery: same chrome as the header search strip, without the search icon
 * or rotating hints — one premium marquee + soft shine sweep.
 */
const StagDiscoverTaglineStrip = memo(function StagDiscoverTaglineStrip({
  navigateTo = '/stag-venues',
}) {
  const navigate = useNavigate();

  const line = (
    <span
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap px-5 py-0.5',
        'text-left text-[11px] font-medium leading-normal tracking-[0.01em]',
        'text-white/58 antialiased',
        'transition-colors duration-300 group-hover:text-white/75',
        'sm:px-7 sm:text-[12px]',
      )}
    >
      Know where to sit, what to order, minimum price, crowd vibe and more.
    </span>
  );

  return (
    <button
      type="button"
      onClick={() => navigate(navigateTo)}
      className="group mt-2 w-full text-left transition-[opacity,transform] duration-200 hover:opacity-[0.98] active:scale-[0.99]"
      aria-label={TAGLINE_ARIA}
    >
      <div
        className={cn(
          'relative flex min-h-[2.5rem] items-center overflow-hidden rounded-[16px] border py-2',
          'border-white/[0.07]',
          'bg-[linear-gradient(165deg,rgba(212,175,55,0.06)_0%,rgba(255,255,255,0.02)_42%,rgba(6,6,7,0.4)_100%)]',
          'shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]',
          'transition-[border-color,box-shadow,background] duration-300 ease-out',
          'group-hover:border-[rgba(201,184,150,0.28)]',
          'group-hover:bg-[linear-gradient(165deg,rgba(212,175,55,0.09)_0%,rgba(255,255,255,0.035)_45%,rgba(6,6,7,0.35)_100%)]',
          'group-hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_0_0_1px_rgba(201,184,150,0.06),0_12px_32px_rgba(0,0,0,0.35)]',
        )}
      >
        <div
          className="pointer-events-none absolute inset-0 z-0 overflow-hidden rounded-[inherit]"
          aria-hidden
        >
          <div className="stag-tagline-shine-sweep absolute inset-y-0 w-[min(44%,10rem)] bg-gradient-to-r from-transparent via-amber-100/[0.09] to-transparent opacity-50" />
        </div>

        <div className="relative z-[1] min-w-0 flex-1">
          <div className="stag-tagline-marquee-track inline-flex w-max">
            {line}
            <span className="inline-flex" aria-hidden>
              {line}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
});

export default StagDiscoverTaglineStrip;
